<template>
<a-modal
  :width="800"
  :bodyStyle="{height: '600px'}"
  :maskStyle="{backgroundColor: 'rgba(10, 15, 26, 0.1)'}"
  v-model="visible"
  :footer="null"
>
  <div class="info-container">
    <div class="avatar">
      <UserAvatar
        :user-avatar="userInfo.avatar"
        style="height: 120px;width: 120px; border-radius: 16px"
      />
    </div>
    <div class="info">
      <a-form
        :form="form"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 19 }"
      >
        <a-form-item :label="$t('personSetting.Name')" :colon="false">
          <a-input v-decorator="['name']" disabled/>
        </a-form-item>
        <a-form-item :label="$t('addressBook.PhoneNumber')" :colon="false">
          <a-input v-decorator="['mobile']" disabled/>
        </a-form-item>
        <a-form-item :label="$t('addressBook.Mail')" :colon="false">
          <a-input v-decorator="['email']" disabled/>
        </a-form-item>
        <a-form-item :label="$t('personSetting.Company')" :colon="false">
          <a-input v-decorator="['corpName']" disabled/>
        </a-form-item>
        <a-form-item :label="$t('personSetting.Position')" :colon="false">
          <a-input class="position" v-decorator="['position']" disabled/>
        </a-form-item>
      </a-form>
    </div>
  </div>
</a-modal>
</template>

<script>
import { mapState } from 'vuex'
import UserAvatar from '@/components/business/avatar/UserAvatar.vue'
import axios from 'axios'
import Global from '@/global'
import { pick } from 'ramda'
export default {
  name: 'PersonalInfo',
  components: {
    UserAvatar
  },
  data() {
    return {
      visible: false,
      form: this.$form.createForm(this, { name: 'personal_info' }),
    }
  },
  computed: {
    ...mapState(['userInfo'])
  },
  methods: {
    openModal() {
      this.visible = true
      this.queryInfoByUid()
    },
    async queryInfoByUid() {
      try {
        const result = await axios.get(`/hiapigw/app/user/someoneUserInfo?uid=${this.userInfo.id}&_id=` + Global.genNonce(5))
        const { code, data: { userInfo } } = result.data
        if (code === 0) {
          const pUserInfo = pick(['name', 'mobile', 'email', 'corpName', 'position'], userInfo)
          const nUserInfo = {}
          Object.keys(pUserInfo).forEach(el => {
            nUserInfo[el] = pUserInfo[el] ? pUserInfo[el] : '-'
          })
          this.form.setFieldsValue(nUserInfo)
        } else {
          throw result.data.comment
        }
      } catch (err) {
        console.warn(err)
      }
    }
  }
}
</script>

<style scoped lang="less">
::v-deep .ant-modal-content {
  border-radius: 16px;
  border: 1px solid #EDEFF2;
  box-shadow: 0 5px 30px 0 rgba(89, 132, 219, 0.08);
  .ant-input[disabled] {
    cursor: auto;
  }
  .ant-form-item-label {
    height: 42px;
    line-height: 42px;
  }
}
.info-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 128px 96px 0;
  .avatar {
    flex: 0 0 120px;
  }
  .info {
    flex: 0 0 360px;
    ::v-deep .ant-row.ant-form-item {
      margin-bottom: 24px;
    }
    ::v-deep input {
      width: 280px;
      height: 42px;
      border: none;
      //background-color: #EFF3F8;
      background-color: #fff;
      border-radius: 8px;
      font-size: 16px;
      font-weight: 400;
      color: #6A6D73;
      margin-left: 20px;
    }
    .position {
      background-color: #fff;
    }
  }
}
</style>
